/**
 * Benutzerrollen gemäß Anforderungen
 */
export enum UserRole {
  Viewer = 'Viewer',
  ErstellenBearbeiten = 'Erstellen und bearbeiten',
  Freigeben = 'Freigeben',
  Geschaeftsfuehrer = 'Geschäftführer',
  Einkauf = 'Einkauf',
  Admin = 'Admin'
}

/**
 * Berechtigungen eines Benutzers
 */
export interface IUserPermissions {
  userId: string;
  email: string;
  displayName: string;
  roles: UserRole[];
  canView: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canApprove: boolean;
  canArchive: boolean;
  canManagePermissions: boolean;
  isAdmin: boolean;
  isEinkauf: boolean;
  isGeschaeftsfuehrer: boolean;
  hasTemporaryPermission?: boolean; // Nur gesetzt wenn getUserPermissionsForResource eine temp. Berechtigung findet
}

/**
 * Benutzer-Profil mit Azure AD-Daten
 */
export interface IUserProfile {
  id: string;
  displayName: string;
  mail: string;
  jobTitle?: string;
  department?: string;
  officeLocation?: string;
  mobilePhone?: string;
  businessPhones?: string[];
  employeeId?: string;
}
